import { gql } from '@apollo/client'

export const TREND_LOCATION_GROUP_SPEED_OF_SERVICE = gql`
  query TrendLocationGroupSpeedOfService(
    $iLocationGroupId: Int!
    $iEndDate: Date!
    $iGroupBy: String!
  ) {
    trendLocationGroupSpeedOfService(
      iLocationGroupId: $iLocationGroupId
      iEndDate: $iEndDate
      iGroupBy: $iGroupBy
    ) {
      nodes {
        startDate
        endDate
        sosDetails
      }
    }
  }
`
